import { IconName, TableBulkActionButton, TableBulkActions, useRowSelection } from '@optimus-web/core';
import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DeleteUsersDialog } from './DeleteUsersDialog';

export const useBulkDelete = () => {
    const {
        rowSelection,
        setRowSelection,
        selectedRowsIds,
        selectedRowsCount,
        hasRowsSelected,
        unselectRow,
        resetRowSelection,
    } = useRowSelection();

    const [dialogProps, toggleDialog] = useDialog();

    const BulkActions = (
        <>
            <TableBulkActions
                disabled={!hasRowsSelected}
                leftSide={
                    hasRowsSelected ? (
                        <LocalizedText textKey={TextKey.SelectedItems} substitutes={{ count: selectedRowsCount }} />
                    ) : null
                }
                rightSide={
                    <>
                        <TableBulkActionButton
                            icon={IconName.Delete}
                            disabled={!hasRowsSelected}
                            onClick={toggleDialog}
                        >
                            <LocalizedText textKey={TextKey.Remove} />
                        </TableBulkActionButton>
                    </>
                }
            />

            <DeleteUsersDialog userIds={selectedRowsIds} onSuccess={resetRowSelection} {...dialogProps} />
        </>
    );

    return {
        BulkActions,
        rowSelection: {
            rowSelection,
            onRowSelectionChange: setRowSelection,
        },
        unselectRow,
    };
};
